import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMsDesignSystem } from '@Mobilesentrix/ms-design-system';
import { provideApollo } from 'apollo-angular';
import { firstValueFrom, of } from 'rxjs';
import { take, switchMap, catchError } from 'rxjs/operators';
import { routes } from './app.routes';
import { apolloOptionsFactory } from './core/graphql/apollo.config';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { responseEnvelopeInterceptor } from './core/interceptors/response-envelope.interceptor';
import { UserInfoService } from './core/services/user-info/user-info.service';
import { AuthService } from './core/auth/auth.service';
function initializePermissions(): Promise<unknown> {
  const userInfo = inject(UserInfoService);
  const authService = inject(AuthService);

  userInfo.load();

  return firstValueFrom(
    userInfo.ready$.pipe(
      take(1),
      switchMap(() => {
        const hasSession = authService.isAuthenticated() || !!userInfo.userInfo();
        return hasSession ? authService.loadPermissions() : of(false);
      }),
      catchError(() => of(false)),
    ),
  );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, responseEnvelopeInterceptor])),
    provideAnimations(),
    provideMsDesignSystem(),
    provideApollo(apolloOptionsFactory),
    provideAppInitializer(initializePermissions),
  ],
};
